import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { LatLngBounds } from "@agm/core";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Subscription, from } from "rxjs";
import { take, concatMap, map } from "rxjs/operators";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { CatalogoService } from "src/app/services/catalogo.service";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { SegmentoService } from "src/app/services/segmento.service";
import { Segmento } from "src/app/models/entities/segmento";
import { LoaderService } from "../../../../services/loader.service";

declare const google: any;

@Component({
  selector: "formato-pdf-carpeta-ejecutiva-estado",
  templateUrl: "./formato-pdf-carpeta-ejecutiva-estado.component.html",
  styleUrls: ["./formato-pdf-carpeta-ejecutiva-estado.component.scss"],
})
export class FormatoPdfCarpetaEjecutivaEstadoComponent
  implements OnInit, OnChanges {
  @ViewChild("formatoHtmlPDF")
  public formatoHtmlPDF: ElementRef;

  @Input("obraSeleccionada")
  public obraSeleccionada: ObraDTO;
  public segmentos: Segmento[] = [];
  // public rutasFotosFull: any[];
  // public rutasFotosAvance: any[];
  // public rutasFotosEstructura: any[];
  // public rutasFotosProblematica: any[];

  public map: any;
  public marcadorInicial: any;
  public marcadorFinal: any;

  public latActual: any;
  public lngActual: any;
  public zoomActual: any;

  public FOTOS_POR_PAGINA = 4;
  public TIPO_OBRA_PROCESO: string = "0";
  public colores: ElementoCatalogo[] = [];
  public datosCoordenadas: any;
  public colorCapa: any;
  public suscripcionColores: Subscription;

  public fechaActual: any;
  public tipoCarpetaYSeccion: any;

  public primerEjercicioFiscal: any;
  public existePrimero: boolean = false;
  public segundoEjercicioFiscal: any;
  public existeSegundo: boolean = false;
  public tercerEjercicioFiscal: any;
  public existeTercero: boolean = false;

  constructor(
    private catalogoService: CatalogoService,
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.loaderService.activarLoaderScreen();
  }

  public ngOnChanges(): void {
    // this.rutasFotosFull = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosFull);
    // this.rutasFotosAvance = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosAvance);
    // this.rutasFotosEstructura = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosEstructura);
    // this.rutasFotosProblematica = this.rellenarArregloConObjetosVacios(this.fichaTecnica.rutasFotosProblematica);
    const monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    const carpetas = ["Asfáltica", "Hidráulica", "Rodaderas"];
    const secciones = ["A1", "A2", "A3", "A4", "6M", "7M", "9M"];
    let fechaConvert: Date = new Date(
      this.obraSeleccionada.obra.fechaActualizacion
    );
    this.fechaActual =
      fechaConvert.getUTCDate() +
      " de " +
      monthNames[fechaConvert.getUTCMonth()] +
      " de " +
      fechaConvert.getUTCFullYear();
    this.tipoCarpetaYSeccion =
      carpetas[this.obraSeleccionada.obra.keyCatCarpeta] +
      " - " +
      secciones[this.obraSeleccionada.obra.keyCatSeccion];
    if (this.obraSeleccionada.obra.ejerciciosFiscales.length) {
      let contadorEjercicios: number = this.obraSeleccionada.obra
        .ejerciciosFiscales.length;
      if (contadorEjercicios > 0) {
        this.primerEjercicioFiscal = this.obraSeleccionada.obra.ejerciciosFiscales[0];
        this.existePrimero = true;
      }
      if (contadorEjercicios > 1) {
        this.segundoEjercicioFiscal = this.obraSeleccionada.obra.ejerciciosFiscales[1];
        this.existeSegundo = true;
      }
      if (contadorEjercicios > 2) {
        this.tercerEjercicioFiscal = this.obraSeleccionada.obra.ejerciciosFiscales[2];
        this.existeTercero = true;
      }
    }
    this.obtenerCatalogos();
    this.obtenerCoordenadas();
  }

  // public rellenarArregloConObjetosVacios(source: any[]): any[] {
  //   if (source) {
  //     let dest = source.slice(0);
  //     let cantidadFotosFaltantes = this.FOTOS_POR_PAGINA - source.length;
  //     for (let indice = 0; indice < cantidadFotosFaltantes; indice++) {
  //       dest.push({});
  //     }
  //     return dest;
  //   }
  // }

  public obtenerCatalogos(): void {
    this.suscripcionColores = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .subscribe((colores: ElementoCatalogo[]) => (this.colores = colores));
  }

  public async obtenerCoordenadas() {
    this.segmentos = await this.capaService
      .findByKeyLevantamientoObra(
        this.obraSeleccionada.obra.keyLevantamientoObra
      )
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              capa.key
                ? this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
                : null
            )
          )
        ),
        take(1)
      )
      .toPromise();
    this.datosCoordenadas = this.segmentos[0].coordenadas;
    this.obtenerMarcadorInicial();
    this.obtenerMarcadorFinal();
  }

  public obtenerMarcadorInicial(): void {
    this.marcadorInicial = {
      lat: this.segmentos[0].coordenadas[
        this.segmentos[0].coordenadas.length - 1
      ].latitud,
      lng: this.segmentos[0].coordenadas[
        this.segmentos[0].coordenadas.length - 1
      ].longitud,
    };
  }

  public obtenerMarcadorFinal(): void {
    this.marcadorFinal = {
      lat: this.segmentos[0].coordenadas[0].latitud,
      lng: this.segmentos[0].coordenadas[0].longitud,
    };
  }

  public mapReady(event: any): void {
    this.map = event;
    this.centrarPolyline();
    this.loaderService.desactivarLoaderScreen();
    console.log(event);
  }

  public centrarPolyline(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const elementoObra of this.datosCoordenadas) {
      bounds.extend(
        new google.maps.LatLng(elementoObra.latitud, elementoObra.longitud)
      );
    }
    this.map.fitBounds(bounds);
  }

  public cambioZoom(event: any): void {
    this.zoomActual = event;
  }

  public cambioCentro(event: any): void {
    this.latActual = event.lat;
    this.lngActual = event.lng;
  }

  public ngOnDestroy(): void {
    if (this.suscripcionColores) {
      this.suscripcionColores.unsubscribe();
    }
  }
}
